import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import ArrowRight from 'components/Icons/ArrowRight'
import BrowseAllReports from 'components/Icons/BrowseAllReports'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import { Link } from 'react-router-dom'

const t = buildTranslate('nav.customers_menu.sections.insights_lab_v2')

const INSIGHTS_LAB_PATH = '/insights_lab'
// The drawer draws a taller, rounder card than the dropdown -- a bigger tap
// target, per its own redline.
const CARD_HEIGHT = '59px'
const DRAWER_CARD_MIN_HEIGHT = '62px'
// One step darker than belizeHole10 for the hover. Deliberate deviation: the
// palette has no belize-05, so there is no token for this tint.
const CARD_HOVER_BACKGROUND = '#DCEAF5'
// Both icon components render 14px by default; the design draws them larger.
const GLYPH_SIZE = '19px'
const ARROW_SIZE = '15px'

type Props = {
  onClick?: () => void
  isLeftNav?: boolean
}

// The persistent "Explore all reports" card in the Customers dropdown footer,
// below the Favorites overflow link. Not a NavLink: the design is a
// title + subtitle card rather than a single-line nav row.
const ExploreAllReportsLink = ({
  onClick,
  isLeftNav = false,
}: Props): JSX.Element => {
  const [css] = useStyletron()

  return (
    <Link
      to={INSIGHTS_LAB_PATH}
      onClick={onClick}
      className={`d-flex align-items-center justify-content-between w-100 ${css(
        {
          ...(isLeftNav
            ? { minHeight: DRAWER_CARD_MIN_HEIGHT, padding: '10px 16px' }
            : { height: CARD_HEIGHT, padding: '0 16px' }),
          gap: '12px',
          borderRadius: isLeftNav ? '8px' : '4px',
          backgroundColor: palette.belizeHole10,
          ':hover': {
            backgroundColor: CARD_HOVER_BACKGROUND,
          },
          ':focus-visible': {
            outline: `2px solid ${palette.belizeHole}`,
            outlineOffset: '2px',
          },
        }
      )}`}
    >
      <span className={`d-flex align-items-center ${css({ gap: '12px' })}`}>
        <BrowseAllReports
          fillColor={palette.belizeHole}
          className={css({ width: GLYPH_SIZE, height: GLYPH_SIZE })}
        />
        <span className="d-flex flex-column">
          <Text.BodyText4
            bold
            tag="span"
            color="primary"
            className={css({ lineHeight: '17px' })}
          >
            {t('explore_all_reports')}
          </Text.BodyText4>
          <Text.BodyText5
            tag="span"
            color="grey90"
            className={css({
              lineHeight: '16px',
              letterSpacing: '0.5px',
              marginTop: '2px',
            })}
          >
            {t('explore_all_reports_subtitle')}
          </Text.BodyText5>
        </span>
      </span>
      <ArrowRight
        fillColor={palette.belizeHole}
        className={css({ width: ARROW_SIZE, height: ARROW_SIZE })}
      />
    </Link>
  )
}

export default ExploreAllReportsLink
